import React from 'react';
import { SkipNavLink, SkipNavContent } from '@reach/skip-nav';

import DarkOverlay from '@common/DarkOverlay';
import Header from '@components/minimal/Header';
import Footer from '@components/minimal/Footer';

const Minimal = ({ children }) => {
  return (
    <>
      <Header />
      <DarkOverlay/>
      <SkipNavLink>{'Skip to Content'}</SkipNavLink>
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
    </>
  )
}

export default Minimal
